import {DirectionType} from './types';

export const TRANSITION_DURATION = 0.28;
export const TRANSITION_EASE = [0.4, 0, 0.2, 1] as const;

export const slideVariants = {
  enter: (direction: DirectionType) => ({
    y: direction === 'forward' ? 32 : -32,
    opacity: 0,
  }),
  center: {
    y: 0,
    opacity: 1,
  },
  exit: (direction: DirectionType) => ({
    y: direction === 'forward' ? -32 : 32,
    opacity: 0,
  }),
};
